import React from 'react';

const Forbidden = () => {
    return <h2>403</h2>;
};

export default Forbidden;
